const CART_BLOCK_ID = 'evereve-cart-block';
class SwymSaveForLaterLink extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('product-id');
    this.variantId = this.getAttribute('variant-id');
    this.productUrl = this.getAttribute('product-url');
    this.sectionId = this.getAttribute('section-id') || null;
    this.itemLimit = this.getAttribute('item-limit');
    this.timeoutId = null;

    this.button = this.querySelector('button');
    this.sfl = null;

    this.handleSaveForLater = this.handleSaveForLater.bind(this);
    this.modal = this.querySelector('.modal');
  }

  connectedCallback() {
    if (!this.button) {
      console.error('SwymSaveForLaterLink requires a <button> element.');
      return;
    }

    if (!this.validateAttributes()) {
      this.hideButton();
      return;
    }

    this.showButton();
    this.button.addEventListener('click', this.handleSaveForLater);
    this.addEventListener('dialog:after-hide', this.handleModalClose);
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.handleSaveForLater);
    }
    this.addEventListener('dialog:after-hide', this.handleModalClose);
  }

  validateAttributes() {
    if (!this.productId || !this.variantId || !this.productUrl) {
      /* eslint-disable comma-dangle */
      console.error(
        `SwymSaveForLaterLink is missing required attributes: 
        productId: ${this.productId}, 
        variantId: ${this.variantId}, 
        productUrl: ${this.productUrl}`
      );
      /* eslint-enable comma-dangle */
      return false;
    }
    return true;
  }

  async initSwym() {
    if (typeof SaveForLater === 'undefined' || !window.SaveForLaterInstance) {
      console.error('SaveForLater instance is not available.');
      this.hideButton();
      return false;
    }

    this.sfl = window.SaveForLaterInstance;
    return true;
  }

  handleModalClose() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.updateButtonState();
  }

  hideButton() {
    if (this.button) {
      this.button.style.display = 'none';
    }
  }

  showButton() {
    if (this.button) {
      this.button.style.display = 'inline-block';
    }
  }

  async handleSaveForLater() {
    if (!this.sfl) {
      const initialized = await this.initSwym();
      if (!initialized) return;
    }

    this.button.disabled = true;

    const product = this.productData;

    try {
      this.updateButtonState('Saving...');
      await this.sfl.add([product], this.itemLimit);
      if (this.sectionId) {
        await this.fetchAndUpdateSection();
      }

      const initEvent = new CustomEvent('EE:sfl:initialized', { bubbles: true });
      document.dispatchEvent(initEvent);
    } catch (error) {
      if (error.type === 'itemLimit') {
        this.modal.setAttribute('open', '');
        this.timeoutId = setTimeout(() => {
          this.modal.removeAttribute('open');
        }, 8000);
      } else {
        console.error('Failed to save product:', error);
      }
    } finally {
      this.button.disabled = false;
    }
  }

  async fetchAndUpdateSection() {
    const fetchUrl = `${window.location.pathname}?section_id=${this.sectionId}`;

    try {
      const res = await fetch(fetchUrl);

      if (!res.ok) {
        throw new Error(`HTTP error! ${res.status}`);
      }

      const htmlContent = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, 'text/html');

      const targetSection = doc.getElementById(`shopify-section-${this.sectionId}`);
      const sectionHTML = targetSection?.innerHTML;

      if (sectionHTML) {
        const targetElement = document.getElementById(`shopify-section-${this.sectionId}`) || document.getElementById(CART_BLOCK_ID);
        if (targetElement) {
          targetElement.setHTMLUnsafe(sectionHTML);
          const initEvent = new CustomEvent('EE:sfl:ready', { bubbles: false });
          document.dispatchEvent(initEvent);
        } else {
          console.error('Section ID not found');
        }
      } else {
        console.error('Section HTML not found in the response.');
      }
    } catch (error) {
      console.error('Failed to fetch and update:', error);
    }
  }

  updateButtonState(text, state) {
    if (this.button) {
      if (!text) {
        this.button.textContent = 'Save for Later';
        return;
      }

      this.button.textContent = text;

      if (state === 'error') {
        this.button.classList.add('error');
        setTimeout(() => this.button.classList.remove('error'), 5000);
      }
    }
  }

  get productData() {
    return {
      epi: Number(this.variantId),
      empi: Number(this.productId),
      du: this.productUrl,
    };
  }
}

customElements.define('swym-sfl-link', SwymSaveForLaterLink);
